/* MDA : mega menu desktop (une coque, un contenu par entree) + tiroir mobile a accordeons + mesure de la navigation.
   Sans dependance. Les liens sont de vrais <a href> : ce fichier n'ajoute que l'ouverture, l'accessibilite et la mesure.
   Mesure : window.mdaTrack (mda-core.js / convention mda_*) ; repli identique seulement s'il est absent. */
(function () {
  'use strict';
  if (window.__mdaMega) return; window.__mdaMega = 1;
  var d = document, w = window, root = d.documentElement;

  function track(name, data) {
    data = data || {};
    /* type de page reel quand la page n'a pas data-mda-page (home, pages Fuel) */
    if (!data.page_type) { var m = w.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page; data.page_type = root.getAttribute('data-mda-page') || (m && m.pageType) || 'other'; }
    /* mda-core.js : window.mdaTrack. La home (mda-home.js, liste d'evenements fermee) passe par le repli identique. */
    if (typeof w.mdaTrack === 'function' && !w.__mdaHome) { try { w.mdaTrack(name, data); } catch (e) {} return; }
    data = Object.assign({ page_type: root.getAttribute('data-mda-page') || 'collection', device_type: (w.innerWidth || 0) < 768 ? 'mobile' : 'desktop' }, data || {});
    try { (w.dataLayer = w.dataLayer || []).push(Object.assign({ event: 'mda_' + name }, data)); } catch (e) {}
    try { if (w.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('mda_' + name, data); } catch (e) {}
  }
  var EV = { category: 'mega_menu_category_click', product: 'mega_menu_product_click', need: 'mega_menu_need_click', routine: 'mega_menu_routine_click', editorial: 'mega_menu_editorial_click' };
  function clickData(a, surface) {
    var name = a.getAttribute('data-mda-name') || (a.querySelector('.mda-mega__name') || a).textContent;
    return {
      menu_group: a.getAttribute('data-mda-group') || '',
      item_name: (name || '').replace(/\s+/g, ' ').replace(/\s*→\s*$/, '').trim(),
      destination: a.pathname + (a.hash || ''),
      position: parseInt(a.getAttribute('data-mda-pos'), 10) || 0,
      surface: surface
    };
  }
  function bindClicks(scope, surface) {
    scope.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[data-mda-ev]');
      if (!a || !scope.contains(a)) return;
      var ev = EV[a.getAttribute('data-mda-ev')];
      if (ev) track(ev, clickData(a, surface));
    });
  }

  /* ---------- Desktop : une coque, le contenu de l'entree active ---------- */
  function initMega(nav) {
    var panel = nav.querySelector('[data-mda-mega]');
    if (!panel) return;
    var header = nav.closest('.header') || d.body;
    var items = [].slice.call(nav.querySelectorAll('.mda-nav__item--mega'));
    var plain = [].slice.call(nav.querySelectorAll('.mda-nav__item:not(.mda-nav__item--mega)'));
    var toggles = [].slice.call(nav.querySelectorAll('.mda-nav__toggle'));
    var cols = [].slice.call(panel.querySelectorAll('.mda-mega__col'));
    var OPEN = 270, CLOSE = 380, SWITCH = 60;
    var tOpen, tClose, tSwitch, open = false, active = null;

    function clear() { clearTimeout(tOpen); clearTimeout(tClose); clearTimeout(tSwitch); }
    function setActive(col) {
      active = col;
      cols.forEach(function (c) { c.classList.toggle('is-active', c.getAttribute('data-mda-col') === col); });
      items.forEach(function (li) { li.classList.toggle('is-active', open && li.getAttribute('data-mda-col') === col); });
      toggles.forEach(function (b) { b.setAttribute('aria-expanded', open && b.getAttribute('data-mda-col') === col ? 'true' : 'false'); });
    }
    function show(col, how) {
      clear();
      if (!open) {
        open = true;
        panel.classList.add('is-open');
        header.classList.add('mda-mega-open');
        track('mega_menu_open', { menu_group: col, trigger: how, surface: 'mega' });
        d.addEventListener('pointerdown', outside, true);
      }
      setActive(col);
    }
    function hide(returnFocus) {
      clear();
      if (!open) return;
      var col = active;
      open = false;
      panel.classList.remove('is-open');
      header.classList.remove('mda-mega-open');
      d.removeEventListener('pointerdown', outside, true);
      setActive(null);
      if (returnFocus) { var b = nav.querySelector('.mda-nav__toggle[data-mda-col="' + col + '"]'); if (b) b.focus(); }
    }
    function outside(e) { if (!nav.contains(e.target)) hide(false); }
    function isMouse(e) { return !e.pointerType || e.pointerType === 'mouse' || e.pointerType === 'pen'; }

    items.forEach(function (li) {
      var col = li.getAttribute('data-mda-col');
      li.addEventListener('pointerenter', function (e) {
        if (!isMouse(e)) return;
        clearTimeout(tClose); clearTimeout(tOpen); clearTimeout(tSwitch);
        if (open) tSwitch = setTimeout(function () { setActive(col); }, SWITCH);
        else tOpen = setTimeout(function () { show(col, 'hover'); }, OPEN);
      });
      li.addEventListener('pointerleave', function () { clearTimeout(tOpen); clearTimeout(tSwitch); });
    });
    plain.forEach(function (li) {
      li.addEventListener('pointerenter', function (e) {
        if (!isMouse(e)) return;
        clearTimeout(tOpen); clearTimeout(tSwitch);
        if (open) { clearTimeout(tClose); tClose = setTimeout(function () { hide(false); }, CLOSE); }
      });
    });
    panel.addEventListener('pointerenter', function () { clearTimeout(tClose); clearTimeout(tSwitch); });
    nav.addEventListener('pointerleave', function (e) {
      if (!isMouse(e)) return;
      clearTimeout(tOpen); clearTimeout(tSwitch);
      if (open) { clearTimeout(tClose); tClose = setTimeout(function () { hide(false); }, CLOSE); }
    });
    nav.addEventListener('pointerenter', function () { clearTimeout(tClose); });
    /* images des cartes : prechargees a la premiere approche du menu (pas au chargement de la page), pour un panneau sans apparition tardive */
    function warm() { [].forEach.call(panel.querySelectorAll('img[loading="lazy"]'), function (im) { im.loading = 'eager'; }); }
    nav.addEventListener('pointerenter', warm, { once: true });
    nav.addEventListener('focusin', warm, { once: true });

    toggles.forEach(function (b) {
      b.addEventListener('click', function (e) {
        var col = b.getAttribute('data-mda-col');
        var kb = e.detail === 0;
        if (open && active === col) { hide(kb); return; }
        show(col, kb ? 'keyboard' : 'click');
        if (kb) { var first = panel.querySelector('.mda-mega__col[data-mda-col="' + col + '"] a'); if (first) first.focus(); }
      });
    });
    nav.addEventListener('keydown', function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc') && open) { e.preventDefault(); e.stopPropagation(); hide(true); }
    });
    nav.addEventListener('focusin', function (e) {
      if (!open) return;
      var c = e.target.closest('.mda-mega__col'), li = e.target.closest('.mda-nav__item--mega');
      if (c) setActive(c.getAttribute('data-mda-col'));
      else if (li) setActive(li.getAttribute('data-mda-col'));
      else if (!panel.contains(e.target)) hide(false);
    });
    nav.addEventListener('focusout', function (e) {
      if (open && e.relatedTarget && !nav.contains(e.relatedTarget)) hide(false);
    });
    panel.addEventListener('click', function (e) { if (e.target.closest('a')) setTimeout(function () { hide(false); }, 0); });
    w.addEventListener('resize', function () { if (open && w.innerWidth < 1068) hide(false); }, { passive: true });
    w.addEventListener('pageshow', function (e) { if (e.persisted) hide(false); });
    bindClicks(nav, 'mega');
  }

  /* ---------- Mobile : tiroir, accordeons (un seul ouvert) ---------- */
  function initDrawer(drawer) {
    var wrap = drawer.closest('details.mobile-toggle-wrapper');
    var summary = wrap && wrap.querySelector('summary.mobile-toggle');
    var secs = [].slice.call(drawer.querySelectorAll('.mda-drawer__sec'));
    function setSec(sec, on) {
      sec.classList.toggle('is-open', on);
      var b = sec.querySelector('.mda-drawer__btn'); if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    secs.forEach(function (sec) {
      var b = sec.querySelector('.mda-drawer__btn');
      if (!b) return;
      b.addEventListener('click', function () {
        var on = !sec.classList.contains('is-open');
        secs.forEach(function (s) { if (s !== sec) setSec(s, false); });
        setSec(sec, on);
        if (on && sec.getBoundingClientRect().top < 0 && sec.scrollIntoView) sec.scrollIntoView({ block: 'start' });
      });
    });
    if (summary) {
      summary.setAttribute('aria-label', 'Menu');
      summary.setAttribute('aria-controls', 'mobile-menu');
      var sync = function () { summary.setAttribute('aria-expanded', wrap.open ? 'true' : 'false'); };
      sync();
      wrap.addEventListener('toggle', function () {
        sync();
        if (wrap.open) track('mobile_menu_open', { menu_group: 'drawer', surface: 'drawer' });
        else secs.forEach(function (s) { setSec(s, false); });
      });
      /* Echap : le theme ferme le tiroir ; on rend le focus au bouton. Tab : focus garde dans le tiroir ouvert. */
      d.addEventListener('keyup', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') && drawer.contains(d.activeElement)) summary.focus();
      });
      wrap.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab' || !wrap.open) return;
        var f = [summary].concat([].slice.call(drawer.parentNode.querySelectorAll('a[href],button,select,input')).filter(function (el) { return el.offsetParent !== null; }));
        var i = f.indexOf(d.activeElement);
        if (e.shiftKey && i <= 0) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && i === f.length - 1) { e.preventDefault(); f[0].focus(); }
      });
    }
    bindClicks(drawer, 'drawer');
  }

  /* ---------- Recherche du header (icone ou champ ; un seul evenement par ouverture) ---------- */
  function initSearch() {
    var header = d.querySelector('.header');
    if (!header) return;
    var last = 0;
    function fire(surface) { var n = Date.now(); if (n - last < 1500) return; last = n; track('search_open_from_header', { menu_group: 'recherche', surface: surface }); }
    header.addEventListener('click', function (e) {
      var q = e.target.closest && e.target.closest('.thb-quick-search');
      if (q) fire(w.innerWidth < 1068 ? 'drawer' : 'header');
    });
    header.addEventListener('focusin', function (e) {
      var inp = e.target;
      if (inp && inp.matches && inp.matches('.searchform--inline input[type="search"], .searchform--inline input[name="q"]')) fire('header');
    });
  }

  function init() {
    var nav = d.querySelector('[data-mda-nav]'); if (nav) initMega(nav);
    var drawer = d.querySelector('[data-mda-drawer]'); if (drawer) initDrawer(drawer);
    /* acces professionnel (cote droit du header) : meme evenement que les liens simples, groupe « professionnels » */
    var pro = d.querySelector('.mda-pro-link'); if (pro && pro.parentNode) bindClicks(pro.parentNode, 'header');
    initSearch();
  }
  if (d.readyState !== 'loading') init(); else d.addEventListener('DOMContentLoaded', init);
})();
